import React from "react";
import { View, ActivityIndicator } from "react-native";

const LoadingScreen = (props) => {
  return (
    <View style={styles.container}>
      <ActivityIndicator size={90} />
    </View>
  );
};

const styles = {
  container: {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    zIndex: 1,
    backgroundColor: "rgba(100,100,100,0.2)",
  },
  loadingText: {},
};

export default LoadingScreen;
